var slidestudy_frame = require('./slidestudy_frame');
var checkProgress = require('./slidestudy_checkprogress');
var slideStudySlide = require('./slidestudy_slide');
var report = require('./slidestudy_report');
var ajaxCalls = require('./ajaxCalls');


var SlideStudy = function(slidestudy,modal,finishLink,adminAjax) {
    var _global = { modal:modal,currentSlide: 0,finishLink:finishLink,adminAjax:adminAjax};
    var frame = slidestudy_frame();


    $(slidestudy).append(frame);
    _global.slidestudy = slidestudy;

    ajaxCalls.getSlides(function(data) {
        _global.slides = data.slides;
        slideStudySlide(_global);
        checkProgress(_global);
    });



    // buttons
    $('#show-answer').click( function() {
        toggleShow();
    });

    $(frame).find('button.previous').click(function() {
        if (_global.currentSlide > 0 ) {
            _global.currentSlide--;
            resetDiagnosis();
            slideStudySlide(_global);
            checkProgress(_global);

        }
    });

    $(frame).find('button.next').click(function() {
        if (_global.currentSlide < _global.slides.length ) {
            _global.currentSlide++ ;
            resetDiagnosis();
            slideStudySlide(_global);
            checkProgress(_global);
        }
    });

    $('#finish').click(function() {
        document.location.href = _global.finishLink;
    });
// Report Button
    $('#report').click(function() {
        report(_global);
    })

    function resetDiagnosis() {
        var diagnosis = $('.diagnosis');
        $(diagnosis).addClass('no-show');

    }
    function toggleShow() {
        var diagnosis = $('.diagnosis');
        if ($(diagnosis).hasClass('no-show')) {
            $(diagnosis).removeClass('no-show');
        } else {
            $(diagnosis).addClass('no-show');
        }
    }
}

module.exports = SlideStudy;


//////////////////
// WEBPACK FOOTER
// ./src/slide_study.js
// module id = 318
// module chunks = 0